import {
    getData,
    postData,
    patchData,
    deleteData
} from './Services'

export const getTallesPanel = async (searchTerm, page, perPage) => {
    let queryParams = [];
    if (searchTerm) {
        queryParams.push(`tal_descripcion=${encodeURIComponent(searchTerm || '')}`);
    }
    if (page) {
        queryParams.push(`page=${encodeURIComponent(page || 1)}`);
    }
    if (perPage) {
        queryParams.push(`perPage=${encodeURIComponent(perPage || 10)}`);
    }
    const queryString = queryParams.length > 0 ? `?&${queryParams.join('&')}` : '';
    return await getData("/talles", queryString);
};

export const getTalleById = async (id) => {
    const res = await getData(`/talles/${id}`)
    return res
}

export const postTalle = async (body) => {
    const res = await postData('/talles', body)
    return res
}

export const patchTalle = async (id, body) => {
    const res = await patchData(`/talles/${id}`, body)
    return res
}

export const deleteTalle = async (id) => {
    const res = await deleteData(`/talles/${id}`)
    return res
}